import router from "@/router.js"

function toPage(page, params) {
    router.push({ name: page, params: params })
}

export default toPage;